import React from 'react'
import { l } from '@manychat/manyui'

const FBChannelTurnedOffNotification = () => {
  return <span>{l.translate('Facebook channel was turned off')}</span>
}

export default FBChannelTurnedOffNotification
